import React from 'react';
import PropTypes from 'prop-types';
import { orderBy } from 'lodash';
import { css } from '@bd/bdui-styles/emotion';
import withData from '@bd/bdcore-data';
import { colors } from '../../styles';
import AreaCard from '../../components/AreaCard';

const styles = css`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 30px 0;
  @media(min-width: 992px) {
    padding: 75px 0 90px 0;
  }
  .HomeAreaSection_headline {
    text-align: center;
    color: ${colors.brand2};
    text-align: center;
    color: ${colors.brand1};
    font-weight: 300;
    font-size: 28px;
    margin: 0 0 20px 0;
    @media(min-width: 992px) {
      font-size: 48px;
    }
  }

  .homepage_webuildArea {
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    justify-content: center;

    .homepage_webuildAreaItem {
      width: 100vw;
      margin: 0 0 20px 0;
      min-width: 280px;
      max-width: 290px;
      @media(min-width: 640px) {
        margin: 0 10px 10px 0;
      }
      @media(min-width: 1290px) {
        margin: 0 15px 15px 0;
        width: auto;
        min-width: 320px;
      }
    }
  }
`;

function HomeAreaSection({ areas }) {
  return (
    <div className={styles}>
      <div className="container">
        <h3 className="HomeAreaSection_headline">Where We Build</h3>
        <div className="homepage_webuildArea">
          {
            orderBy(areas, 'name').map(item => (
              <div className="homepage_webuildAreaItem" key={item.name}>
                <AreaCard area={item} />
              </div>
            ))
          }
        </div>
      </div>
    </div>
  );
}

HomeAreaSection.propTypes = {
  areas: PropTypes.arrayOf(PropTypes.object).isRequired,
};

export default withData(
  {
    areas: true,
  },
)(HomeAreaSection);



// WEBPACK FOOTER //
// ./src/pages/IndexPage/HomeAreaSection.js